.footer {
    position: absolute;
    bottom: 0;
    width: calc(100% - 64px); /* full width minus 32px LR padding */
}
